import { Injectable, Signal, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private requestCount = 0;
  private readonly loading = signal(false);

  get isLoading(): Signal<boolean> {
    return this.loading.asReadonly();
  }

  show(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.loading.set(true);
    }
  }

  hide(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0) {
      this.loading.set(false);
    }
  }
}
